/*
 * Rennsieger — headlight product page.
 *
 * Button variant picker (not dropdowns), live price + availability, the
 * "You're saving $X" pill wired to the REAL Full-Set-vs-2x-single delta,
 * gallery, story read-more, accordions, and the context-aware sticky buy bar.
 * No dependencies; no-ops when its markup is absent.
 */
(function () {
  'use strict';

  var root = document.querySelector('.rsg-hp');
  if (!root) return;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
  }

  /* ---------------- variant picker ---------------- */
  function initVariants() {
    var form = root.querySelector('#rsg-hp-form');
    var buy = root.querySelector('[data-rsg-hp-buy]');
    var vEl = root.querySelector('[data-rsg-hp-variants]');
    var oEl = root.querySelector('[data-rsg-hp-options]');
    if (!form || !buy || !vEl || !oEl) return;

    var variants = JSON.parse(vEl.textContent);
    var optionNames = JSON.parse(oEl.textContent);
    var rows = Array.prototype.slice.call(form.querySelectorAll('[data-rsg-opt-index]'));

    var idInput = form.querySelector('[data-rsg-hp-id]');
    var priceEl = root.querySelector('[data-rsg-hp-price]');
    var wasEl = root.querySelector('[data-rsg-hp-was]');
    var saveEl = root.querySelector('[data-rsg-hp-save]');
    var atc = root.querySelector('[data-rsg-hp-atc]');
    var atcLabel = root.querySelector('[data-rsg-hp-atc-label]');
    var atcPrice = root.querySelector('[data-rsg-hp-atc-price]');
    var stickyDesc = root.querySelector('[data-rsg-sticky-desc]');
    var stickyPrice = root.querySelector('[data-rsg-sticky-price]');

    var sideIndex = parseInt(buy.getAttribute('data-side-index'), 10);
    var driverValue = buy.getAttribute('data-driver-value') || '';

    // Current selection, one value per option, seeded from the .is-sel buttons.
    var selected = optionNames.map(function (_, i) {
      var row = form.querySelector('[data-rsg-opt-index="' + i + '"]');
      var sel = row ? row.querySelector('.is-sel') : null;
      return sel ? sel.getAttribute('data-value') : (row ? row.querySelector('[data-value]').getAttribute('data-value') : '');
    });

    function optKey(v, i) { return v['option' + (i + 1)]; }

    function findVariant(values) {
      for (var k = 0; k < variants.length; k++) {
        var match = true;
        for (var i = 0; i < values.length; i++) {
          if (optKey(variants[k], i) !== values[i]) { match = false; break; }
        }
        if (match) return variants[k];
      }
      return null;
    }

    function cleanSide(v) {
      return v.replace(' │ Save $300', '').replace('(L+R)', '').replace(/\s+/g, ' ').trim();
    }

    function render() {
      var current = findVariant(selected);

      // Availability per button: is the variant you'd get by picking this value,
      // with the other options as they stand, actually purchasable?
      rows.forEach(function (row, i) {
        row.querySelectorAll('[data-rsg-opt-btn]').forEach(function (btn) {
          var val = btn.getAttribute('data-value');
          var trial = selected.slice();
          trial[i] = val;
          var vr = findVariant(trial);
          btn.classList.toggle('is-soldout', !(vr && vr.available));
          btn.classList.toggle('is-sel', selected[i] === val);
        });
      });

      if (!current) {
        atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }

      idInput.value = current.id;
      priceEl.textContent = money(current.price);
      if (atcPrice) atcPrice.textContent = money(current.price);
      atc.disabled = !current.available;
      if (atcLabel) atcLabel.textContent = current.available ? 'Add to cart' : 'Sold out';

      if (wasEl) {
        if (current.compare_at_price && current.compare_at_price > current.price) {
          wasEl.textContent = money(current.compare_at_price);
          wasEl.hidden = false;
        } else {
          wasEl.hidden = true;
        }
      }

      // Save pill — real delta: 2 x the single-side price minus the Full Set.
      if (saveEl) {
        var save = 0;
        if (sideIndex >= 0 && driverValue && selected[sideIndex].indexOf('Full Set') !== -1) {
          var single = selected.slice();
          single[sideIndex] = driverValue;
          var sv = findVariant(single);
          if (sv) save = sv.price * 2 - current.price;
        }
        if (save > 0) {
          saveEl.textContent = "You're saving " + money(save) + '!';
          saveEl.classList.add('is-shown');
        } else {
          saveEl.classList.remove('is-shown');
        }
      }

      if (stickyPrice) stickyPrice.textContent = money(current.price);
      if (stickyDesc) stickyDesc.textContent = sideIndex >= 0 ? cleanSide(selected[sideIndex]) : current.title;
    }

    rows.forEach(function (row, i) {
      row.querySelectorAll('[data-rsg-opt-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selected[i] = btn.getAttribute('data-value');
          render();
        });
      });
    });

    render();
  }

  /* ---------------- gallery ---------------- */
  function initGallery() {
    var main = root.querySelector('[data-rsg-gal-main]');
    var thumbs = root.querySelector('[data-rsg-gal-thumbs]');
    if (!main) return;
    var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));
    function show(i) {
      imgs.forEach(function (m) { m.classList.toggle('is-on', +m.getAttribute('data-i') === i); });
      if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-on', +b.getAttribute('data-i') === i);
      });
    }
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { show(+b.getAttribute('data-i')); });
    });
  }

  /* ---------------- story read-more ---------------- */
  var storyOpen = false;
  function initStory() {
    var toggle = root.querySelector('[data-rsg-story-toggle]');
    var more = root.querySelector('[data-rsg-story-more]');
    var txt = root.querySelector('[data-rsg-story-txt]');
    if (!toggle || !more) return;
    toggle.addEventListener('click', function () {
      storyOpen = !storyOpen;
      more.classList.toggle('is-open', storyOpen);
      toggle.classList.toggle('is-open', storyOpen);
      toggle.setAttribute('aria-expanded', storyOpen ? 'true' : 'false');
      if (txt) txt.textContent = storyOpen ? 'Close' : "See what's inside";
      updateSticky();
    });
  }

  /* ---------------- accordions ---------------- */
  function initAcc() {
    root.querySelectorAll('[data-rsg-acc] .rsg-acc__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var a = q.nextElementSibling;
        var open = q.classList.contains('is-open');
        q.classList.toggle('is-open', !open);
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
      });
    });
  }

  /* ---------------- sticky buy bar ---------------- */
  var bar, btn, buyInView = true;
  function updateSticky() {
    if (!bar) return;
    bar.classList.toggle('is-shown', !buyInView);
    if (storyOpen) {
      btn.textContent = '↑ Back to fitment';
      btn.classList.add('is-ghost');
    } else {
      btn.textContent = 'Select fitment';
      btn.classList.remove('is-ghost');
    }
  }
  function initSticky() {
    bar = root.querySelector('[data-rsg-sticky]');
    var buy = root.querySelector('[data-rsg-hp-buy]');
    if (!bar || !buy) return;
    btn = bar.querySelector('[data-rsg-sticky-btn]');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        buyInView = en[0].isIntersecting;
        updateSticky();
      }, { threshold: 0 }).observe(buy);
    }
    btn.addEventListener('click', function () {
      buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------------- VIN check modal ----------------
   * Submits through Shopify's contact form: a POST to the current page with the
   * form_type=contact fields makes Shopify send the store its inquiry email. We
   * AJAX it so the sleek modal stays put and shows its own success rather than
   * doing a full-page reload. VIN validated client-side; only the VIN is sent.
   */
  function initVin() {
    var modal = root.querySelector('[data-rsg-vin]');
    if (!modal) return;
    // Portal above the sticky header, same as the Notify Me modal.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    var input = modal.querySelector('[data-rsg-vin-input]');
    var emailEl = modal.querySelector('[data-rsg-vin-email]');
    var form = modal.querySelector('#rsg-vin-contact');
    var wrap = modal.querySelector('[data-rsg-vin-form-wrap]');
    var success = modal.querySelector('[data-rsg-vin-success]');
    var submit = modal.querySelector('[data-rsg-vin-submit]');
    var errEl = modal.querySelector('[data-rsg-vin-err]');
    var lastFocus = null;

    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      if (wrap) wrap.hidden = false;
      if (success) success.hidden = true;
      if (errEl) errEl.textContent = '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (input) input.addEventListener('input', function () {
      input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    });

    // Triggers live in the PDP (fitment block), which is inside root.
    root.querySelectorAll('[data-rsg-vin-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(b); });
    });
    modal.querySelectorAll('[data-rsg-vin-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('rsg-vin__scrim')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) errEl.textContent = '';

      var email = emailEl ? (emailEl.value || '').trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        if (errEl) errEl.textContent = 'Please enter a valid email so we can send your result.';
        if (emailEl) emailEl.focus();
        return;
      }
      var vin = (input.value || '').trim();
      if (vin.length < 11) {
        if (errEl) errEl.textContent = "That doesn't look like a full VIN. It should be 17 characters.";
        input.focus();
        return;
      }
      submit.disabled = true;
      submit.textContent = 'Sending…';
      fetch(form.getAttribute('action') || window.location.pathname, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () {
        if (wrap) wrap.hidden = true;
        if (success) success.hidden = false;
        setTimeout(close, 2400);
      }).catch(function () {
        submit.disabled = false;
        submit.textContent = 'Check my fit →';
        if (errEl) errEl.textContent = 'Could not send just now. Please try again, or DM us.';
      });
    });
  }

  function boot() {
    initVariants();
    initGallery();
    initStory();
    initAcc();
    initSticky();
    initVin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
